import React from 'react';

const PremiumUpsellModal = ({ isOpen, onClose, onRequestPremium, listingId }) => {
  const premiumFeatures = [
    {
      icon: '🎯',
      title: 'Teljes marketing',
      description: 'TikTok, Facebook, Instagram kampányok'
    },
    {
      icon: '📸',
      title: 'Profi fotózás',
      description: 'Helyszíni fotózás és videózás'
    },
    {
      icon: '🤝',
      title: 'Influencer push',
      description: 'Megjelenés influencer csatornákon'
    },
    {
      icon: '⭐',
      title: 'Top kiemelés',
      description: 'Garantált első oldal 30 napig'
    },
    {
      icon: '💬',
      title: 'Lead kezelés',
      description: 'Mi kezeljük az érdeklődőket'
    },
    {
      icon: '📊',
      title: 'Heti riportok',
      description: 'Részletes statisztikák és elemzések'
    }
  ];

  const handleRequest = () => {
    onRequestPremium({
      listingId,
      package: 'premium',
      price: 99000
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto border-2 border-white/[0.08] shadow-2xl">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-yellow-500 via-amber-500 to-orange-500 p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <span className="text-3xl">💎</span>
                <h2 className="text-2xl md:text-3xl font-black text-white">
                  Dőlj hátra – Mi eladjuk helyetted
                </h2>
              </div>
              <p className="text-white/90">
                Teljes körű szolgáltatás az elejétől a végéig
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white/20 rounded-full p-2 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Price Box */}
          <div className="bg-gradient-to-br from-yellow-500/20 to-orange-500/20 backdrop-blur-xl rounded-2xl p-6 border-2 border-yellow-500/30 mb-6 text-center">
            <div className="text-sm text-gray-300 mb-2">Egyszeri díj</div>
            <div className="text-5xl font-black text-white mb-2">
              99.000 Ft
            </div>
            <div className="text-gray-300 text-sm">
              vagy sikerdíj alapon: 1% az eladási árból
            </div>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            {premiumFeatures.map((feature, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-xl p-4 border border-white/[0.08]"
              >
                <div className="flex items-start gap-3">
                  <div className="text-3xl">{feature.icon}</div>
                  <div>
                    <h4 className="text-white font-bold mb-1">{feature.title}</h4>
                    <p className="text-gray-300 text-sm">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Process Timeline */}
          <div className="bg-gradient-to-br from-blue-500/20 to-purple-500/20 backdrop-blur-xl rounded-xl p-6 border border-blue-500/30 mb-6">
            <h3 className="text-white font-black text-lg mb-4">📅 Hogyan működik?</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">1</div>
                <div>
                  <div className="text-white font-semibold">Konzultáció</div>
                  <div className="text-gray-300 text-sm">Megbeszéljük az elvárásokat és stratégiát</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="bg-purple-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">2</div>
                <div>
                  <div className="text-white font-semibold">Tartalom készítés</div>
                  <div className="text-gray-300 text-sm">Profi fotók, videók, hirdetések</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="bg-pink-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">3</div>
                <div>
                  <div className="text-white font-semibold">Marketing kampány</div>
                  <div className="text-gray-300 text-sm">Több csatornás megjelenés, influencer push</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">4</div>
                <div>
                  <div className="text-white font-semibold">Lead kezelés</div>
                  <div className="text-gray-300 text-sm">Mi kezeljük az érdeklődőket helyetted</div>
                </div>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 backdrop-blur-xl rounded-xl p-6 border border-green-500/30 mb-6">
            <h3 className="text-white font-black text-lg mb-4">📊 Eredmények</h3>
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-3xl font-black text-white mb-1">2-4</div>
                <div className="text-gray-300 text-sm">hét alatt eladva</div>
              </div>
              <div>
                <div className="text-3xl font-black text-white mb-1">95%</div>
                <div className="text-gray-300 text-sm">sikeres eladás</div>
              </div>
              <div>
                <div className="text-3xl font-black text-white mb-1">50+</div>
                <div className="text-gray-300 text-sm">érdeklődő átlag</div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="flex-1 bg-white/10 hover:bg-white/20 text-white font-bold py-4 rounded-xl transition-colors border-2 border-white/[0.08]"
            >
              Most nem
            </button>
            <button
              onClick={handleRequest}
              className="flex-1 bg-gradient-to-r from-yellow-500 via-amber-500 to-orange-500 hover:from-orange-500 hover:to-yellow-500 text-white font-black py-4 rounded-xl shadow-xl hover:shadow-2xl hover:shadow-yellow-500/50 transition-all"
            >
              Kérem a teljes szolgáltatást! 💎
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PremiumUpsellModal;
